import { defaultParamsSerializer, handleApiResponse } from '@/functions';
import { useInvalidateQueries } from '@/hooks';
import { apiClient } from '@/components/api';
import { useQuery } from '@tanstack/react-query';
import type { IPromoCodeOffer } from '@/interfaces';
import type { Paginated } from '@/lib/interface';
import type { PromoCodeStatusEnum } from '@/enums';
import routes from '@/lib/routes';

export type TGetPromoCodesParams = {
	status?: PromoCodeStatusEnum[];
	page?: number | string;
	limit?: number | string;
};

export const useRequestGetPromoCodes = (params?: TGetPromoCodesParams) => {
	const { invalidate } = useInvalidateQueries();

	const { isFetching, data, error } = useQuery({
		queryKey: [routes.api.promoCodes.base, params],
		queryFn: () =>
			apiClient
				.get<Paginated<IPromoCodeOffer>>(routes.api.promoCodes.base, params, {
					paramsSerializer: defaultParamsSerializer,
				})
				.then(handleApiResponse),
	});

	const refresh = () => invalidate(routes.api.promoCodes.base);

	return {
		data: data as Paginated<IPromoCodeOffer>,
		offers: (data?.data ?? []) as IPromoCodeOffer[],
		isLoading: isFetching && !data,
		isFetching,
		refresh,
		error,
	};
};
